import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trash2 } from 'lucide-react';
import {
  clearConversationById,
  setSelectedPortfolio
} from '../../../../store/slices/gpt.slice';

const ChatList = ({
  conversations,
  onSetActiveConversation,
  onRenameConversation,
  activeId,
}) => {
  const dispatch = useDispatch();
  const responses = useSelector((state) => state.gptApi.responses);

  const handleDelete = (e, id) => {
    e.stopPropagation();
    dispatch(clearConversationById({ id }));
  };

  const handleChatSelection = (id) => {
    // Get the conversation data
    const conversation = responses[id];

    // If this is a portfolio chat (has groupId that's not the same as id)
    if (conversation && conversation.groupId && conversation.groupId !== id) {
      // Set the selected portfolio to the groupId
      dispatch(setSelectedPortfolio(conversation.groupId));
    }

    // Call the original onSetActiveConversation
    onSetActiveConversation(id);
  };

  return (
    <div className="w-full p-4">
      {conversations.map(({ id, title }) => (
        <div
          key={id}
          className="relative group flex items-center justify-between p-3 rounded-full bg-gray-100 hover:bg-gray-200 my-2 transition-colors"
          onClick={() => handleChatSelection(id)}
          style={{
            cursor: 'pointer',
            fontWeight: activeId === id ? 'bold' : 'normal',
          }}
        >
          <span className="truncate flex-1 mr-2">{title}</span>
          <button
            onClick={(e) => handleDelete(e, id)}
            className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-gray-300 rounded-full"
            title="Delete conversation"
          >
            <Trash2 size={16} className="text-gray-600 hover:text-red-500" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ChatList;